export function OpenAddToBagModalButton(props: { onClick: () => void }) {
  const { onClick } = props;

  return (
    <button
      className="item--actions--button"
      data-test-id="open-add-to-bag-modal-button"
      onClick={onClick}>
      Add to Bag
    </button>
  );
}
